import { http, HttpResponse } from 'msw';
// import { getInsurances, getNotes, getTasks } from '@maia/shared';

function baseResponse<T>(response: T, page?: number, limit?: number) {
  return {
    statusCode: 200,
    response,
    success: true,
    error: null,
    pagination: {
      page_number: page,
      page_size: limit,
      total_results: 110,
      total_pages: 11,
    },
  };
}

export const handlers = [
  // TODO: Add mock
  http.get('http://localhost:3000/quotations', ({ request }) => {
    // const url = new URL(request.url);
    // const limit = parseInt(url.searchParams.get('limit') ?? '10');
    // const page = parseInt(url.searchParams.get('page') ?? '1');
    // const insurances = getInsurances(limit);
    return HttpResponse.json(baseResponse({}));
  }),
  // TODO: Add mock
  http.get('http://localhost:3000/quotations/:guid', () => {
    // const insurances = getInsurances(1)[0];
    return HttpResponse.json(baseResponse({}));
  }),
  // TODO: Add mock
  http.get('http://localhost:3000/quotations/:guid/notes', ({ request }) => {
    // const url = new URL(request.url);
    // const limit = parseInt(url.searchParams.get('limit') ?? '10');
    // const page = parseInt(url.searchParams.get('page') ?? '1');
    // const notes = getNotes(limit);
    return HttpResponse.json(baseResponse({}));
  }),
  // TODO: Add mock
  http.get('http://localhost:3000/quotations/:guid/tasks', ({ request }) => {
    // const url = new URL(request.url);
    // const limit = parseInt(url.searchParams.get('limit') ?? '10');
    // const page = parseInt(url.searchParams.get('page') ?? '1');
    // const tasks = getTasks(limit);
    return HttpResponse.json(baseResponse({}));
  }),
];
